import React from 'react'

export const TimelineScrollPositionContext = React.createContext({ scrollLeft: 0, scrollTop: 0 })
